class AccordionGroup {
    constructor(el) {
        this.$el = $(el);

        if(this.$el.length) {
            this.init();
        }
    }

    init() {
        this.accordions = [];
        this.accordionsDOMNodes = [];

        const $accordions = this.$el.find('.accordion');
        
        if($accordions.length) {
            this.bindEvents();
            this.createAccordions($accordions);
        }
    }

    bindEvents() {
        this.onAccordionOpenedFn = this.onAccordionOpened.bind(this);
        this.onAccordionOpenRequestFn = this.onAccordionOpenRequest.bind(this);

        $(window).on('accordion:opened', this.onAccordionOpenedFn);
        $(window).on('accordion:open', this.onAccordionOpenRequestFn);
    }

    createAccordions($accordions) {
        $accordions.each((index, accordion) => {
            this.accordionsDOMNodes.push(accordion);
            this.accordions.push(new Accordion(accordion));
        });
    }

    onAccordionOpenRequest(e, data) {
        if(this.accordionsDOMNodes.includes(data.$el[0])) {
            this.accordions.forEach((accordion) => {
                if(accordion.$el[0] === data.$el[0]) {
                    accordion.open();
                }
            });
        }
    }

    onAccordionOpened(e, data) {
        if(this.accordionsDOMNodes.includes(data.$el[0])) {
            this.accordions.forEach((accordion) => {
                if(accordion.$el[0] !== data.$el[0]) {
                    accordion.close();
                }
            });
        }
    }
}

class Accordion {
    constructor(el) {
        this.$el = $(el);

        if(this.$el.length) {
            this.init();
        }
    }

    init() {
        this.openedClass = 'accordion--opened';
        this.isOpened = this.$el.hasClass(this.openedClass);
        
        this.$title = this.$el.find('.accordion__title');
        this.$content = this.$el.find('.accordion__content');

        if(this.$title.length) {
            if(this.isOpened) this.open();
            else this.close();

            this.bindEvents();
        }


    }

    bindEvents() {
        this.onToggleFn = this.onToggle.bind(this);

        this.$title.on('click', this.onToggleFn);
    }

    onToggle() {
        this.isOpened = !this.isOpened;

        if(this.isOpened) this.open();
        else this.close();
    }

    open() {
        this.isOpened = true;

        this.$el.addClass(this.openedClass);
        this.$content.css('max-height', this.$content[0].scrollHeight + 'px');
        
        $(window).trigger('accordion:opened', {$el: this.$el});
    }

    close() {
        this.isOpened = false;

        this.$el.removeClass(this.openedClass);
        this.$content.css('max-height', 0);
    }
}

export {Accordion};
export default AccordionGroup;